import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getServerlessTechnologyBenefits(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Výrazně nižší náklady",
			desc: "Pokud se vyvíjí na cloudu, platíte pouze za to, co opravdu využijete. V případě vývoje na serverech musíte řešit nákup hardwaru i jeho údržbu.",
		},
		{
			title: "Lepší zabezpečení",
			desc: "Cloud AWS poskytuje špičkové bezpečnostní nástroje, díky kterým budou vaše data ve větším bezpečí, než kdyby ležela na firemním serveru.",
		},
		{
			title: "Škálovatelnost a flexibilita",
			desc: "Při vývoji na cloudu můžeme přidávat nebo ubírat výpočetní výkon podle aktuální potřeby. U fyzických serverů je škálování složité, často vyžaduje nákup nového hardwaru.",
		},
		{
			title: "Automatické zálohování",
			desc: "AWS i další cloudové služby umí automaticky zálohovat, takže se nemusíte obávat, že byste z hodiny na hodinu přišli o cenná firemná data.",
		},
	];
}
